import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpApiService } from '../http.api.service';
import { EfateSetup } from '../../models/echo/efate-setup';

@Injectable({
  providedIn: 'root'
})
export class EfateSetupApiService extends HttpApiService {
  override apiUrl: string = environment.BAMS_Api_URL;

  getEfateSetupByMoleculeAndGeography(moleculePk: number, geography: string): Observable<EfateSetup | undefined> {
    const endpoint = `api/efate/setup/${moleculePk}/${encodeURIComponent(geography)}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  saveEfateSetup(pObject: any): Observable<any> {
    const body = JSON.stringify(pObject);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const endpoint = 'api/efate/setup';
    return this.put(endpoint, body, headers)
      .pipe(map((data: any) => data?.Value ?? data));
  }
}